module.exports = __webpack_public_path__ + "assets/img/TLXD-3.791720c8.jpg";